import { useTranslation } from "react-i18next";
import { FaCheckCircle } from "react-icons/fa";

const CheckOutPage = () => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col items-center justify-center gap-y-6">
      <div className="border-2 p-3 rounded-full border-green-600">
        <FaCheckCircle size={62} color="#16a34a" />
      </div>
      <h1 className="text-xl font-bold">{t("checkout_complete")}</h1>
      <p className="text-center text-gray-800">{t("service_reward_message")}</p>
    </div>
  );
};

export default CheckOutPage;
